module.exports = __webpack_public_path__ + "assets/img/custom.9597c946.jpg";